import { render } from "./SliderSection.vue?vue&type=template&id=b39d0b18"
import script from "./SliderSection.vue?vue&type=script&lang=js"
export * from "./SliderSection.vue?vue&type=script&lang=js"

import "./SliderSection.vue?vue&type=style&index=0&id=b39d0b18&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__